import React from "react";
import Seo from "../components/Seo";
import "./TermosDeUsoPrivacidade.css";

const TermsAndPrivacy = () => {
    return (
        <div className="terms-container">
            <Seo
                title="Termos de Uso e Privacidade"
                description="Termos de uso e política de privacidade da Rádio Famílias Online: como tratamos seus dados com transparência e segurança."
                path="/politicas"
            />
            <h1>Termos de Uso e Política de Privacidade</h1>

            <section>
                <h2>1. Introdução</h2>
                <p>
                    Ao acessar e utilizar nosso site, você concorda com os seguintes
                    Termos de Uso e nossa Política de Privacidade. Caso não concorde,
                    recomendamos que não utilize nossos serviços.
                </p>
            </section>

            <section>
                <h2>2. Coleta de Informações</h2>
                <p>
                    A Rádio Famílias Online disponibiliza aos usuários em geral o site Rádio Famílias Online (www.radiofamiliasonline.com).
                    Ao utilizar o SITE, o usuário declara estar ciente de que podem ser recolhidas informações
                    relativas à sua navegação, tais como, mas sem limite, termos de busca, páginas mais visitadas,
                    anunciantes consultados, entre outras informações. As informações terão caráter estatístico
                    e anônimo, não sendo passíveis de identificarem, dentro do estado atual da técnica, a pessoa
                    natural do usuário.
                </p>
                <p>
                    A captura das informações será realizada por todo e qualquer meio técnico não vedado pela
                    legislação vigente, incluindo a utilização de cookies de navegação, que não terão outras
                    funções que não as citadas na presente Política no que toca aos dados dos usuários.
                </p>
                <p>
                    Os cookies não capturam informações pessoais identificáveis e, caso deseje, o usuário
                    poderá apagá-los de seu computador utilizando as ferramentas do seu navegador (browser).
                    Todas as informações coletadas serão armazenadas na base de dados que dispõe de sistemas
                    de segurança compatíveis com os padrões do mercado brasileiro e internacional.
                </p>
                <p>
                    Todas as informações recolhidas referentes à navegação do usuário poderão ser utilizadas
                    para aperfeiçoamento de sua experiência no SITE, especialmente para análise e adoção de
                    melhorias do sítio eletrônico, como funcionalidades apropriadas, acesso intuitivo e amigável,
                    entre outras ações, a fim de que SITE possa atender aos usuários com eficiência e precisão
                    crescentes.
                </p>
                <p>
                    As informações estatísticas ou anônimas poderão ser compartilhadas com empresas parceiras,
                    dentro e fora do Rádio Famílias Online, para elaboração de material promocional e marketing.
                </p>
                <p>
                    As informações estatísticas e anônimas coletadas pelos cookies poderão, mas sem obrigatoriedade,
                    ser agregadas ao seu cadastro, caso você submeta seus dados pessoais por meio de algum dos
                    formulários disponíveis no SITE.
                </p>
            </section>

            <section>
                <h2>3. Uso dos Dados</h2>
                <p>
                    As informações coletadas são utilizadas para personalizar conteúdo,
                    melhorar nossos serviços e garantir a segurança da plataforma.
                </p>
            </section>

            <section>
                <h2>4. Segurança</h2>

                <p>
                    Implementamos medidas para proteger suas informações contra acessos
                    não autorizados, mas recomendamos que os usuários também adotem
                    práticas seguras.
                </p>
                <p>
                    O SITE, os serviços online, as mensagens de e-mail e o material publicitário poderão usar
                    “cookies” e outras tecnologias, tais como pixel tags e web beacons. Essas tecnologias nos
                    ajudam a entender melhor o comportamento do usuário, nos dizem quais partes de nosso site
                    as pessoas visitaram e facilitam e medem a eficácia da publicidade e das pesquisas na web.
                    Nós tratamos as informações obtidas por meio de cookies e outras tecnologias como informações
                    não-pessoais. Entretanto, na medida em que o endereço de IP (Internet Protocol) ou
                    identificadores semelhantes sejam considerados informações pessoais pela lei local,
                    nós também trataremos esses identificadores como informação pessoal. Da mesma forma,
                    na medida em que a informação não-pessoal seja combinada com informação pessoal, nós
                    tratamos a informação combinada como informação pessoal para os fins desta Política de
                    Privacidade. Se você desejar bloquear os cookies, consulte as orientações/configurações
                    de seu navegador.
                </p>

                <p>
                    O SITE e os seus parceiros também usam cookies e outras tecnologias para relembrarem informações
                    pessoais quando você usa o site, serviços online e aplicativos. A nossa meta nesses casos é
                    fazer com que a sua experiência seja mais conveniente e personalizada.
                    Como ocorre na maioria dos sites e aplicativos, nós obtemos algumas informações automaticamente
                    e armazenamos em arquivos de log. Entre essas informações estão endereços IP, tipo de navegador
                    e idioma, provedor de serviços de Internet (ISP), páginas de consulta e saída, sistema
                    operacional, informações sobre data e horário e dados sobre a sequência de cliques.
                    Nós usamos essas informações para entender e analisar tendências, administrar o site,
                    aprender sobre o comportamento do usuário no site e obter informações demográficas sobre
                    a nossa base de usuários de maneira geral. O SITE poderá usar estas informações em nossos
                    serviços de marketing e publicidade.
                </p>
                <p>
                    Em algumas de nossas mensagens de e-mail, nós usamos uma “URL click-through” vinculada
                    ao conteúdo do SITE. Quando os usuários clicam em uma dessas URLs, são enviados para um
                    servidor web diferente antes de chegarem à página de destino no nosso site. Nós monitoramos
                    esses dados de click-through para entender o interesse em determinados tópicos e avaliar a
                    eficácia das comunicações com os nossos clientes. Se você preferir não ser monitorado dessa
                    maneira, não clique em texto nem nos links de imagens nas mensagens de e-mail.
                </p>
                <p>
                    Os “pixel-tags” nos permitem enviar mensagens de e-mail em formatos que os clientes possam
                    ler e nos dizer se o e-mail foi aberto ou não. Nós podemos usar essas informações para reduzir
                    ou eliminar as mensagens enviadas aos usuários.
                </p>

            </section>

            <section>
                <h2>5. Alterações</h2>
                <p>
                    Buscando a contínua melhoria, o Rádio Famílias Online poderá alterar a qualquer momento esta
                    Política, sendo que as alterações serão divulgadas no SITE para consulta a qualquer
                    tempo.
                </p>
                <p>
                    Ao utilizar os serviços do SITE, o usuário concorda e aceita os termos da Política
                    vigente na data de utilização, cabendo ao mesmo verificá-la previamente cada vez que
                    visitar o SITE.
                </p>
                <p>
                    Versão 01
                </p>
            </section>

            <section>
                <h2>6. Contato</h2>
                <p>
                    Para dúvidas ou solicitações relacionadas a estes termos, entre em
                    contato pelo e-mail: radiofamiliasonline@gmail.com.
                </p>
            </section>
        </div>
    );
};

export default TermsAndPrivacy;
